
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/online-store",
      function () {
        return require("private-next-pages/features/online-store.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/online-store"])
      });
    }
  